import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const NotificationIconOutlined: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={svgWidth}
            height={svgHeight}
            fill="none"
            viewBox="0 0 24 24"
            {...restProps}
        >
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M18.875 8.826a3 3 0 100-6 3 3 0 000 6zM9.125 21.75a2.087 2.087 0 004.005 0M11.125 3V.75M18.648 11.96c.189 5.757 1.477 6.79 1.477 6.79h-18s1.5-1.916 1.5-8.25a7.507 7.507 0 019.724-7.165"
            ></path>
        </svg>
    );
};

export default React.memo(NotificationIconOutlined);
